export function visualCocktailShakerSort(array){
  let animations = []; //[type, i, j, arr[i], arr[j], reads, writes] 0=read, 1=write
  let reads = 0;
  let writes = 0;
  let swapped;

	do {
		for (let i = 0; i < array.length - 2; i++) {
			if(array[i] > array[i+1]) {
        reads += 2;
        writes += 2;
        animations.push([0,i,i+1,array[i],array[i+1],reads,writes]);
        animations.push([1,i,i+1,array[i],array[i+1],reads,writes]);
				[array[i],array[i+1]] = [array[i+1],array[i]];
        animations.push([1,i,i+1,array[i],array[i+1],reads,writes]);
        animations.push([0,i,i+1,array[i],array[i+1],reads,writes]);
				swapped = true;
			}
      else {
        reads += 2;
        animations.push([0,i,i+1,array[i],array[i+1],reads,writes]);
      }
		}

		if(!swapped) {
			break;
		}

		swapped = false;
		for(let i = array.length - 2; i > 0; i--) {
			if(array[i] > array[i+1]) {
        reads += 2;
        writes += 2;
        animations.push([0,i,i+1,array[i],array[i+1],reads,writes]);
        animations.push([1,i,i+1,array[i],array[i+1],reads,writes]);
        [array[i],array[i+1]] = [array[i+1],array[i]];
        animations.push([1,i,i+1,array[i],array[i+1],reads,writes]);
        animations.push([0,i,i+1,array[i],array[i+1],reads,writes]);
				swapped = true;
			}
      else {
        reads += 2;
        animations.push([0,i,i+1,array[i],array[i+1],reads,writes]);
      }

		}
	} while(swapped);

  return animations;
}
